// extracted by mini-css-extract-plugin
module.exports = {"offices-list":"OfficesList_offices-list__1UJG1","offices-list__title":"OfficesList_offices-list__title__37KPb"};